import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords = [],
  ogTitle,
  ogDescription,
  ogImage,
  canonical
}) => {
  const siteUrl = 'https://packetpath.ca'; // Update with your actual domain
  const defaultTitle = 'Packet Path - IT Solutions & Digital Services';
  const defaultDescription = 'Your trusted partner for innovative tech solutions, networking infrastructure, cybersecurity services, and comprehensive digital solutions.';
  
  const fullTitle = title ? `${title} | Packet Path` : defaultTitle;
  const metaDescription = description || defaultDescription;
  const metaKeywords = keywords.length > 0 ? keywords.join(', ') : '';
  
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      {metaKeywords && <meta name="keywords" content={metaKeywords} />}
      
      {/* Canonical URL */}
      {canonical && <link rel="canonical" href={`${siteUrl}${canonical}`} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={ogTitle || fullTitle} />
      <meta property="og:description" content={ogDescription || metaDescription} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta property="og:site_name" content="Packet Path" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogTitle || fullTitle} />
      <meta name="twitter:description" content={ogDescription || metaDescription} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      
      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="author" content="Packet Path" />
    </Helmet>
  );
};

export default SEO;
